// @ts-check
/* global Tygh $ module require*/
'use strict';

declare var plupload;

import { ProductPreview } from './product_preview';
import { Notifications } from '../../tv_utils/notifications';

/**
 * Class to handle photo uploads for in-browser product preview.
 */
export class ProductPreviewUploader {
    dispatch: string;
    elements: {[key: string]: HTMLElement} = {};
    extension_string: string;
    extensions: string[];
    photo_upload_path: string;
    photo_upload_percent: number;
    product_preview: ProductPreview;
    uploader: any;
    upload_params: {[key: string]: any};

    constructor(product_preview: ProductPreview) {
        this.product_preview = product_preview;
    }
    
     /**
     * Instantiates an instance of a plupload uploader.
     *
     */
     init_uploader() {
        this.elements.choose_file_btn = document.getElementById(`js-btnPickfiles-photo-upload`);
        this.elements.choose_file_btn.addEventListener('click', () => {
            document.getElementById(`js-pickfiles-photo-upload`).click();
        });
        
        const artwork_extensions = <HTMLInputElement>document.getElementById('js-preview-artwork-extensions');
        this.extension_string = artwork_extensions.value;
        this.extensions = this.extension_string.split(',');
        this.dispatch = `${window.location.origin}/index.php?dispatch=tv_artwork.upload_from_cart`;
        this.upload_params = {
            'configuration_id': this.product_preview.configurator_v2.configuration_id,
            'image_index': 0,
            'preview_only': 1
        };
        
        this.uploader = new plupload.Uploader({
            runtimes: 'html5',
            browse_button: `js-pickfiles-photo-upload`,
            container: `container-photo-upload`,
            max_file_size: '1536mb',
            chunk_size: '5mb',
            url: this.dispatch,
            flash_swf_url: 'js/addons/tv_artwork/plupload.flash.swf',
            silverlight_xap_url: 'js/addons/tv_artwork/plupload.silverlight.xap',
            filters: [
                {title: 'Artwork Files', extensions: this.extension_string}
            ],
            init: {
                BeforeUpload: this.set_upload_params.bind(this),
                FilesAdded: this.upload_files_added.bind(this),
                UploadProgress: this.upload_progress.bind(this),
                UploadComplete: this.upload_complete.bind(this)
            }
        });

        this.uploader.init();
    }

    /**
     * Sets the upload parameters for plupload to be sent along in the request to the controller.
     *
     * @returns {void}
     */
    set_upload_params(): void {
        this.upload_params.configuration_id = this.product_preview.configurator_v2.configuration_id;
        this.uploader.settings.multipart_params = this.upload_params;
    }

    /**
     * Method to check that all files that are to be uploaded match our accepted file extensions.
     *
     * @param {plupload.Uploader} uploader_instance for plupload.
     * @param {array} files of the files to be added to the upload queue.
     * @returns {void}
     */
    upload_files_added(uploader_instance, files): void {
        for (const i in files) {
            // check if file type is accepted
            if (!this.check_file_extension(files[i].name, true)) {
                // if not accepted remove file from upload list and pop alert
                this.uploader.removeFile(files[i]);
                Notifications.set_notification(
                    'E',
                    'Upload Error.',
                    `File type (extension) not accepted for: ${files[i].name}`,
                    false
                );
            } else {
                this.start_upload();
            }
        }
    }

    /**
     * Updates the progress bar with the file upload percentage.
     *
     * @param {plupload.Uploader} uploader_instance for plupload.
     * @param {Object} file plupload object.
     * @returns {void}
     */
    upload_progress(uploader_instance, file): void {
        // Update progress bar to reflect percentage of transfer
        this.photo_upload_percent = file.percent;
        this.product_preview.update_canvas();
    }

    /**
     * Checks that if a file failed uploaded that an error notification is thrown and if it was a success
     * the upload fields get hidden.
     *
     * @param {plupload.Uploader} uploader_instance for plupload.
     * @param {array} files array of the files that have been uploaded.
     * @returns {void}
     */
    upload_complete(uploader_instance, files): void {
        // Check to see if the file failed upload and display an error notification.
        if (files[0].status === plupload.FAILED) {
            this.product_preview.loading_photo = false;
            this.photo_upload_percent = 0;

            Notifications.set_notification(
                'E',
                'Failed to upload artwork.',
                'tv_artwork_order_upload_error',
                true
            );

            files[0].status = plupload.QUEUED;
            uploader_instance.state = plupload.QUEUED;
            uploader_instance.trigger('StateChanged');
            return;
        }

        // Get cleaned file name.
        const file_name = (files[0]['name']).replace(/[^\w\._]+/g, '_');
        const configuration_id = this.product_preview.configurator_v2.configuration_id;
        const img_url = `${this.photo_upload_path}${configuration_id}/${file_name}`;
        this.product_preview.photo_uploaded(img_url);

    }

    /**
     * Checks whether a file names extension matches a list of accepted or rejected extensions.
     *
     * @param {string} file_name the file name to check.
     * @param {boolean} search_accepted_exts flag to indicate whether to check against accepted extensions.
     * @returns {boolean} indicates whether file name extension matched an entry in the list.
     */
    check_file_extension(file_name: string, search_accepted_exts: boolean): boolean {
        //  Get file extension.
        const file_ext = file_name.split('.').pop().toLowerCase();

        if (search_accepted_exts) {
            // Check file ext against accepted extensions, if it matches one of those, accept the file.
            return this.extensions.includes(file_ext);
        }

        // Check file ext against rejected extensions, if it doesn't match one of those, accept the file.
        return !this.extensions.includes(file_ext);
    }

    /**
     * Starts the upload process.
     *
     * @returns {void}
     */
    start_upload(): void {
        // Check the required field values.
        if (this.uploader.files.length
        ) {
            // Display the progress bar.
            this.product_preview.photo_upload_started();
            this.photo_upload_percent = 0;
            // Remove all but most recently submitted image.
            for (let i = this.uploader.files.length; i > 1; i--) {
                this.uploader.files.shift();
            }
            // Start the upload.
            this.uploader.start();

        }
    }

}

